/**
 * Ayuda — Compras → Facturas
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PUR_INVOICES_ITEM = {
  id: 'invoices',
  screenId: 'adm-pur-invoices',
  label: 'Facturas',
  description: 'Registrá facturas de compra de proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá cargás las facturas que te emiten tus proveedores. Podés hacerlo a mano, traer líneas desde un remito pendiente o registrar notas de crédito y débito vinculadas a una factura original.',
      },
      {
        title: 'Paso 1 — Buscar facturas',
        fields: [
          { label: 'Fecha Desde / Fecha Hasta', description: 'Filtrá por fecha de emisión.' },
          { label: 'Proveedor', description: 'Elegí un proveedor para acotar la búsqueda.' },
          { label: 'Buscar', description: 'Actualiza la lista.' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Fecha, Proveedor, Tipo, Número, Total y Moneda.',
          'Ícono de lápiz — la edición no está disponible; el sistema lo informa.',
          'Ícono de cruz (×) — eliminar la factura.',
        ],
        paragraphs: ['Tocá una fila para ver el detalle completo.'],
      },
      {
        title: 'Paso 3 — Cargar una factura nueva',
        intro: 'El botón + abre «Factura de Proveedores».',
      },
      {
        title: 'Encabezado',
        fields: [
          { label: 'Fecha', description: 'Fecha contable del comprobante.' },
          { label: 'Fecha de emisión', description: 'Fecha que figura en la factura del proveedor.' },
          { label: 'Tipo de factura', description: 'Factura A, B, C, nota de crédito, nota de débito, etc.' },
          { label: 'Centro / Número', description: 'Punto de venta y número del comprobante del proveedor.' },
        ],
      },
      {
        title: 'Proveedor',
        intro:
          'Buscá el proveedor en la base de datos o cargá sus datos si es nuevo. Podés usar la búsqueda en AFIP con CUIT cuando corresponda.',
      },
      {
        title: 'Comprobantes relacionados',
        bullets: [
          'En facturas normales — «Crear desde Remito» trae líneas de remitos del proveedor aún no facturados. Si el remito tiene precio, se convierte de la moneda del remito a la de la factura.',
          'En notas de crédito o débito — indicá tipo, punto de venta y número de la factura original y tocá Buscar.',
        ],
      },
      {
        title: 'Líneas de la factura',
        fields: [
          { label: 'Moneda', description: 'Moneda del comprobante. Si no es pesos, completá la cotización.' },
          { label: 'Producto, Cantidad, Precio unitario', description: 'Cada línea del comprobante. El subtotal se calcula solo.' },
          {
            label: 'Alícuota de IVA',
            description: 'Aparece cuando el tipo de factura discrimina IVA. Elegí 21 %, 10,5 %, etc.',
          },
          { label: 'Agregar línea', description: 'Sumá más productos.' },
        ],
      },
      {
        title: 'Totales y confirmación',
        fields: [
          { label: 'Totales', description: 'Resumen por concepto impositivo (neto gravado, IVA, etc.) antes de guardar.' },
          { label: 'Observaciones', description: 'Notas generales (opcional).' },
          { label: 'Limpiar formulario / Confirmar', description: 'Limpiar borra todo. Confirmar registra la factura.' },
        ],
        paragraphs: [
          'Los pagos a proveedores se registran desde Administración → Pagos, no en esta pantalla.',
        ],
      },
      {
        title: 'Ver el detalle de una factura',
        bullets: [
          'Datos del comprobante, proveedor, artículos y totales (neto, IVA, percepciones si las hay).',
          'Ver Pagos — pagos imputados a esa factura.',
          'Ver Comprobantes Relacionados — remitos, notas u otras facturas vinculadas.',
          'Eliminar factura — con confirmación.',
        ],
      },
      {
        title: 'Eliminar una factura',
        intro:
          'Tocá la cruz en la lista o «Eliminar factura» en el detalle. Confirmá con «SI» o cancelá con «NO».',
      },
    ],
  },
}
